// Dummy updates API for What's New card and updates page
import api from '../utils/apiUtils';
let notificationsData = [];
const API_URL = '/notifications/';

export const fetchNotifications = async () => {
  try {
    const resp = await api.post(API_URL + 'list', {});
    notificationsData = resp.data.notifications;
    return resp.data.notifications;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};